/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

export default function FileIcon({
  width = 32,
  height = 40,
}) {
  return (
    <svg width={width} height={height} viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 0.75H20C20.0911 0.75 20.1793 0.777281 20.2539 0.827148L20.3232 0.883789L31.1162 11.6768C31.2019 11.7625 31.25 11.8788 31.25 12V36C31.25 37.7949 29.7949 39.25 28 39.25H4C2.20507 39.25 0.75 37.7949 0.75 36V4C0.750001 2.20507 2.20508 0.75 4 0.75Z" fill="white" stroke="#D0D5DD" strokeWidth="1.5"/>
      <path d="M20 0.5V8C20 10.2091 21.7909 12 24 12H31.5" stroke="#D0D5DD" strokeWidth="1.5" />
    </svg>
  );
}

FileIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};
